/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { PropertyMatrixBaseService } from '../property-matrix-base-service';
import { PropertyMatrixConfiguration } from '../property-matrix-configuration';
import { PropertyMatrixStrictHttpResponse } from '../property-matrix-strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class ZoningService extends PropertyMatrixBaseService {
  constructor(
    config: PropertyMatrixConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiV1ZoningMetroRegionIdGet
   */
  static readonly ApiV1ZoningMetroRegionIdGetPath = '/api/v1/Zoning/MetroRegion/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1ZoningMetroRegionIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ZoningMetroRegionIdGet$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ZoningService.ApiV1ZoningMetroRegionIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as PropertyMatrixStrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1ZoningMetroRegionIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ZoningMetroRegionIdGet(params: {
    id: number;
    context?: HttpContext
  }
): Observable<void> {

    return this.apiV1ZoningMetroRegionIdGet$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiV1ZoningMetroRegionGet
   */
  static readonly ApiV1ZoningMetroRegionGetPath = '/api/v1/Zoning/MetroRegion';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1ZoningMetroRegionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ZoningMetroRegionGet$Response(params?: {
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ZoningService.ApiV1ZoningMetroRegionGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as PropertyMatrixStrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1ZoningMetroRegionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ZoningMetroRegionGet(params?: {
    context?: HttpContext
  }
): Observable<void> {

    return this.apiV1ZoningMetroRegionGet$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiV1ZoningSchemeNameIdGet
   */
  static readonly ApiV1ZoningSchemeNameIdGetPath = '/api/v1/Zoning/SchemeName/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1ZoningSchemeNameIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ZoningSchemeNameIdGet$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ZoningService.ApiV1ZoningSchemeNameIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as PropertyMatrixStrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1ZoningSchemeNameIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ZoningSchemeNameIdGet(params: {
    id: number;
    context?: HttpContext
  }
): Observable<void> {

    return this.apiV1ZoningSchemeNameIdGet$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiV1ZoningSchemeNameGet
   */
  static readonly ApiV1ZoningSchemeNameGetPath = '/api/v1/Zoning/SchemeName';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1ZoningSchemeNameGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ZoningSchemeNameGet$Response(params?: {
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ZoningService.ApiV1ZoningSchemeNameGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as PropertyMatrixStrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1ZoningSchemeNameGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ZoningSchemeNameGet(params?: {
    context?: HttpContext
  }
): Observable<void> {

    return this.apiV1ZoningSchemeNameGet$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiV1ZoningZoneTypeIdGet
   */
  static readonly ApiV1ZoningZoneTypeIdGetPath = '/api/v1/Zoning/ZoneType/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1ZoningZoneTypeIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ZoningZoneTypeIdGet$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ZoningService.ApiV1ZoningZoneTypeIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as PropertyMatrixStrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1ZoningZoneTypeIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ZoningZoneTypeIdGet(params: {
    id: number;
    context?: HttpContext
  }
): Observable<void> {

    return this.apiV1ZoningZoneTypeIdGet$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiV1ZoningZoneTypeGet
   */
  static readonly ApiV1ZoningZoneTypeGetPath = '/api/v1/Zoning/ZoneType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1ZoningZoneTypeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ZoningZoneTypeGet$Response(params?: {
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ZoningService.ApiV1ZoningZoneTypeGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as PropertyMatrixStrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1ZoningZoneTypeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ZoningZoneTypeGet(params?: {
    context?: HttpContext
  }
): Observable<void> {

    return this.apiV1ZoningZoneTypeGet$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiV1ZoningLandUseRightIdGet
   */
  static readonly ApiV1ZoningLandUseRightIdGetPath = '/api/v1/Zoning/LandUseRight/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1ZoningLandUseRightIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ZoningLandUseRightIdGet$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ZoningService.ApiV1ZoningLandUseRightIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as PropertyMatrixStrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1ZoningLandUseRightIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ZoningLandUseRightIdGet(params: {
    id: number;
    context?: HttpContext
  }
): Observable<void> {

    return this.apiV1ZoningLandUseRightIdGet$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiV1ZoningLandUseRightGet
   */
  static readonly ApiV1ZoningLandUseRightGetPath = '/api/v1/Zoning/LandUseRight';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1ZoningLandUseRightGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ZoningLandUseRightGet$Response(params?: {
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ZoningService.ApiV1ZoningLandUseRightGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as PropertyMatrixStrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1ZoningLandUseRightGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ZoningLandUseRightGet(params?: {
    context?: HttpContext
  }
): Observable<void> {

    return this.apiV1ZoningLandUseRightGet$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiV1ZoningLandUseIdGet
   */
  static readonly ApiV1ZoningLandUseIdGetPath = '/api/v1/Zoning/LandUse/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1ZoningLandUseIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ZoningLandUseIdGet$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ZoningService.ApiV1ZoningLandUseIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as PropertyMatrixStrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1ZoningLandUseIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ZoningLandUseIdGet(params: {
    id: number;
    context?: HttpContext
  }
): Observable<void> {

    return this.apiV1ZoningLandUseIdGet$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiV1ZoningLandUseGet
   */
  static readonly ApiV1ZoningLandUseGetPath = '/api/v1/Zoning/LandUse';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1ZoningLandUseGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ZoningLandUseGet$Response(params?: {
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ZoningService.ApiV1ZoningLandUseGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as PropertyMatrixStrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1ZoningLandUseGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ZoningLandUseGet(params?: {
    context?: HttpContext
  }
): Observable<void> {

    return this.apiV1ZoningLandUseGet$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponse<void>) => r.body as void)
    );
  }

}
